import { useSelector } from "react-redux";
import { Redirect, Route } from "react-router-dom";
import User from "redux/models/user";
import { selectUser } from "redux/slices/userSlice";
import { hasAccessToRoute } from "utilities/generalUtility";

export default function RouteWithSubRoutes(route) {
  const userSlice = useSelector(selectUser);

  return (
    <Route
      path={route.path}
      render={(props) => {
        // Check authentication
        if (
          !route.authenticated ||
          (route.authenticated && User.isTokenAvailable())
        ) {
          if (
            ["/login", "/forgot-password", "/set-password"].includes(
              route.path,
            ) &&
            User.isTokenAvailable()
          )
            return (
              <Redirect
                to={{
                  pathname: "/",
                  state: { from: props.location },
                }}
              />
            );
          // Check permissions
          const hasAccess = hasAccessToRoute(
            route,
            userSlice.roles,
            userSlice.clients,
            userSlice.details?.isSuperAdmin,
          );

          if (hasAccess) {
            const component = <route.component {...props} route={route} />;
            return route.layout ? (
              <route.layout>{component}</route.layout>
            ) : (
              component
            );
          }
          return (
            <Redirect
              to={{
                pathname: "/unauthorized",
              }}
            />
          );
        }
        return (
          <Redirect
            to={{
              pathname: "/login",
              state: { from: props.location },
            }}
          />
        );
      }}
    />
  );
}
